export enum DiceReceiverManagerEvents {
    /**
     * Emitted when the receiver is configured with a realm and logged in user.
     * Signals the application that it is ready to receive load requests.
     */
    CONFIGURED = 'configured',
    /**
     * Emitted when an error occurs.
     */
    ERROR = 'error',
    /**
     * Emitted when the settings have changed.
     */
    SETTINGS_CHANGED = 'SETTINGS_CHANGED'
}
